import { metaSet, metaGet } from './db.js';

export async function requestPersistence(): Promise<boolean> {
  if (!('storage' in navigator) || !navigator.storage.persist) return false;
  const already = await navigator.storage.persisted?.().catch(() => false);
  if (already) {
    await metaSet('storage_persisted', true);
    return true;
  }
  try {
    const granted = await navigator.storage.persist();
    await metaSet('storage_persisted', granted);
    return granted;
  } catch {
    return false;
  }
}

export async function isPersisted(): Promise<boolean> {
  if ('storage' in navigator && navigator.storage.persisted) {
    return await navigator.storage.persisted().catch(() => false);
  }
  return (await metaGet('storage_persisted')) === true;
}

export async function estimateStorage(): Promise<{ usage?: number; quota?: number }> {
  if ('storage' in navigator && navigator.storage.estimate) {
    return navigator.storage.estimate().catch(() => ({}));
  }
  return {};
}
